import { render, staticRenderFns } from "./lawdettli.vue?vue&type=template&id=34dee66c&scoped=true&"
import script from "./lawdettli.vue?vue&type=script&lang=js&"
export * from "./lawdettli.vue?vue&type=script&lang=js&"
import style0 from "./lawdettli.vue?vue&type=style&index=0&id=34dee66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dee66c",
  null
  
)

export default component.exports